module.exports = __webpack_public_path__ + "static/img/tm01.c399286d.png";